(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kana-back-to-top"] && !Shopify.designMode) return;
  try {
    (() => {
  const button = document.getElementById('kana-back-to-top');
  if (!button || button.dataset.ready) return;
  button.dataset.ready = 'true';
  let queued = false;
  const update = () => { button.hidden = window.scrollY < 400; queued = false; };
  const onScroll = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('pageshow', update);
  button.addEventListener('click', () => {
    const target = document.querySelector('header a[href], #header-group a[href], #MainContent');
    target?.focus({ preventScroll: true });
    window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  });
  update();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kana-download-consent"] && !Shopify.designMode) return;
  try {
    (() => {
    function setup(scope) {
      scope.querySelectorAll('[data-kana-download-consent]').forEach(root => {
        const form = root.closest('form');
        if (!form || root.dataset.bound === 'true') return;
        root.dataset.bound = 'true';
        const checkbox = root.querySelector('[data-consent-checkbox]');
        const error = root.querySelector('[data-consent-error]');
        const checkout = form.querySelector('[name="checkout"]');
        const fields = ['text', 'version', 'products', 'time', 'variants'].map(key => root.querySelector('[data-consent-' + key + ']'));
        function clear() { fields.forEach(field => { field.value = ''; }); }
        function reset() {
          if (checkbox) checkbox.checked = false;
          clear();
          clearError();
        }
        function clearError() {
          root.classList.remove('is-invalid', 'is-pulsing');
          checkbox?.removeAttribute('aria-invalid');
          if (error) error.hidden = true;
        }
        function showError() {
          root.classList.add('is-invalid');
          root.classList.remove('is-pulsing');
          if (error) error.hidden = false;
          checkbox?.setAttribute('aria-invalid', 'true');
          void root.offsetWidth;
          root.classList.add('is-pulsing');
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          root.scrollIntoView({ block: 'nearest', behavior: reduced ? 'auto' : 'smooth' });
          checkbox?.focus({ preventScroll: true });
        }
        function record() {
          clear();
          if (!checkbox?.checked) return;
          fields[0].value = root.querySelector('[data-consent-label]').textContent.trim();
          fields[1].value = root.dataset.version;
          const products = Array.from(root.querySelectorAll('[data-variant-id]'), item => ({ variant: item.dataset.variantId, quantity: item.dataset.quantity, title: item.textContent.trim() }));
          fields[2].value = products.map(item => item.title).join('; ');
          fields[4].value = JSON.stringify(products);
          fields[3].value = new Date().toISOString();
        }
        reset();
        if (checkout?.hasAttribute('data-consent-js-required')) checkout.disabled = checkout.dataset.launchLocked === 'true';
        checkbox?.addEventListener('change', () => { record(); if (checkbox.checked) clearError(); });
        checkbox?.addEventListener('invalid', event => { event.preventDefault(); showError(); });
        form.addEventListener('submit', event => {
          if (event.submitter?.name === 'update') { reset(); return; }
          if (checkbox && !checkbox.checked) { event.preventDefault(); clear(); showError(); return; }
          record();
        });
        window.addEventListener('pageshow', reset);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(document));
    else setup(document);
    document.addEventListener('shopify:section:load', event => setup(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kana-feedback-form"] && !Shopify.designMode) return;
  try {
    (() => {
  const start = () => {
    const form = document.getElementById('KanaFeedbackForm');
    const messageNode = document.querySelector('[data-feedback-messages]');
    if (!form || !messageNode || form.dataset.kanaReady) return;
    form.dataset.kanaReady = 'true';
    const messages = messageNode.dataset;
    const finish = kind => {
      const home = new URL(messages.home, window.location.origin);
      const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (preview) home.searchParams.set('preview_theme_id', preview);
      try {
        sessionStorage.removeItem('kana-feedback-native');
        sessionStorage.setItem('kana-feedback-receipt', JSON.stringify({ kind, at: Date.now() }));
      } catch {}
      home.hash = 'kana-feedback-' + kind;
      window.location.replace(home.href);
    };
    if (form.querySelector('[data-feedback-saved]')) { finish('success'); return; }
    const returnTarget = new URL(window.location.href);
    returnTarget.hash = '';
    returnTarget.searchParams.set('contact_posted', 'true');
    form.querySelector('[name="return_to"]').value = returnTarget.pathname + returnTarget.search;
    const nativeAction = new URL(form.action, window.location.origin);
    nativeAction.hash = '';
    form.action = nativeAction.href;
    const stars = [...form.querySelectorAll('.kana-star')];
    const group = form.querySelector('.kana-rating-stars');
    const hint = form.querySelector('[data-rating-hint]');
    const clearPreview = () => { delete group.dataset.preview; stars.forEach(s => s.classList.remove('is-preview')); };
    stars.forEach((star, i) => {
      star.addEventListener('pointerenter', e => {
        if (e.pointerType !== 'mouse') return;
        group.dataset.preview = String(i + 1);
        stars.forEach((s, j) => s.classList.toggle('is-preview', j <= i));
      });
      star.querySelector('input').addEventListener('change', e => {
        clearPreview(); hint.textContent = messages.selected.replace('[count]', e.target.value);
      });
    });
    group.addEventListener('pointerleave', clearPreview);
    const panel = form.querySelector('[data-feedback-reward]');
    const choice = form.querySelector('[data-reward-choice]');
    const product = form.querySelector('#FeedbackProduct');
    const email = form.querySelector('#FeedbackEmail');
    const error = form.querySelector('[data-feedback-error]');
    const button = form.querySelector('button[type=submit]');
    const endpoint = '/apps/kana-kurs/api/feedback-submissions';
    let state = null;
    let submissionId = null;
    let nativeSubmit = false;
    const eligibleForReward = () => Boolean(state?.available && !state.loginRequired && state.products?.includes(product.value));
    const refreshChoice = () => {
      const eligible = eligibleForReward();
      email.readOnly = eligible;
      if (eligible) email.value = state.email;
      if (!state?.available || state.loginRequired) return;
      panel.hidden = !eligible;
      choice.hidden = !eligible;
      form.querySelector('[data-reward-terms]').hidden = !eligible;
    };
    product.addEventListener('change', refreshChoice);
    const loadState = () => fetch(endpoint, { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store', signal: AbortSignal.timeout(12000) })
      .then(async response => {
        if (!response.ok) throw new Error('feedback-state');
        state = await response.json();
        if (state.available && state.loginRequired) { panel.hidden = false; form.querySelector('[data-reward-login]').hidden = false; }
        refreshChoice();
        return true;
      }).catch(() => false);
    let statePromise = loadState();
    form.addEventListener('submit', async event => {
      if (nativeSubmit) return;
      if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); return; }
      event.preventDefault();
      if (button.disabled) return;
      if (!submissionId) submissionId = crypto.randomUUID();
      const text = button.textContent;
      button.disabled = true; button.textContent = messages.sending; error.hidden = true;
      try {
        if (!await statePromise) { statePromise = loadState(); if (!await statePromise) throw new Error('feedback-state'); }
        refreshChoice();
        if (!eligibleForReward()) {
          button.disabled = false; button.textContent = text;
          setTimeout(() => {
            try { sessionStorage.setItem('kana-feedback-native', String(Date.now())); } catch {}
            nativeSubmit = true;
            form.requestSubmit(button);
            nativeSubmit = false;
          }, 0);
          return;
        }
        const response = await fetch(endpoint, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({
          csrf: state.csrf, submissionId, rating: Number(form.querySelector('input[name="contact[Bewertung]"]:checked').value),
          product: product.value, name: form.querySelector('#FeedbackName').value,
          body: form.querySelector('#FeedbackBody').value, improve: form.querySelector('#FeedbackImprove').value,
          publication: form.querySelector('#FeedbackPublish').checked, rewardConsent: true
        }) });
        const data = await response.json();
        if (!response.ok || !data.saved) throw new Error('feedback');
        const kind = data.reward === 'pending' ? 'gift' : data.reward === 'sent' ? 'already' : 'issue';
        finish(kind);
      } catch {
        error.textContent = messages.error; error.hidden = false;
        button.disabled = false; button.textContent = text;
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kana-feedback-receipt"] && !Shopify.designMode) return;
  try {
    (() => {
  const start = () => {
    const toast = document.querySelector('[data-feedback-toast]');
    if (!toast || document.querySelector('[data-feedback-messages]') || toast.dataset.ready) return;
    toast.dataset.ready = 'true';
    let kind = null;
    try {
      const receipt = JSON.parse(sessionStorage.getItem('kana-feedback-receipt') || 'null');
      const nativeAt = Number(sessionStorage.getItem('kana-feedback-native'));
      sessionStorage.removeItem('kana-feedback-receipt');
      sessionStorage.removeItem('kana-feedback-native');
      if (receipt && Date.now() >= receipt.at && Date.now() - receipt.at < 120000) kind = receipt.kind;
      if (!kind && nativeAt && Date.now() >= nativeAt && Date.now() - nativeAt < 600000 && document.querySelector('[data-feedback-native-saved]')) kind = 'success';
    } catch {}
    const fallback = window.location.hash.match(/^#kana-feedback-(success|gift|already|issue)$/);
    if (fallback) {
      kind = kind || fallback[1];
      history.replaceState(history.state, '', window.location.pathname + window.location.search);
    }
    if (!['success', 'gift', 'already', 'issue'].includes(kind)) return;
    const toTop = () => window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    toTop();
    requestAnimationFrame(toTop);
    if (document.readyState !== 'complete') window.addEventListener('load', toTop, { once: true });
    document.body.append(toast);
    toast.hidden = false;
    toast.querySelector('[data-toast-text]').textContent = toast.dataset[kind];
    const timer = setTimeout(() => { toast.hidden = true; }, 10000);
    toast.querySelector('[data-toast-close]').addEventListener('click', () => {
      clearTimeout(timer);
      toast.hidden = true;
    });
    window.addEventListener('pagehide', () => { clearTimeout(timer); toast.hidden = true; }, { once: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
  } catch(e) { console.error(e); }
})();

})();
